import type { CRMTypes } from '../utils/constants'
import type { UserRoleForTable } from '../utils/roles'

export type CloudType = 'AWS' | 'AZURE' | 'GCP' | 'REDHAT'
export type ProductType = 'oppsync' | 'cloudfaas' | 'flyout'

export type TestButtonStatus = 'standBy' | 'loading' | 'success' | 'error'

export enum AuthProtocol {
  PASSWORD = 'PASSWORD',
  EXTERNAL = 'EXTERNAL',
}

export enum CloudTypeEnum {
  AWS = 'AWS',
  AZURE = 'AZURE',
  GCP = 'GCP',
  REDHAT = 'REDHAT',
}

export type Product = 'oppsync' | 'flyout' | 'cloudfaas' | 'funding'
export type ActiveProducts = Product[] | string[]

export type PartnershipTypeValue = 'TECHNOLOGY_PARTNER' | 'CONSULTING_PARTNER'

export type AceEventReceiptValidField = {
  status: 'in_progress' | 'success' | 'failed' | 'timed_out'
  startedAt: string
  expiresAt?: string | null
  completedAt?: string | null
  result?: {
    success: boolean
    partnerId?: string
    opportunityTitle?: string
    opportunityId?: string
    createSubmitted?: boolean
    receiptFound?: boolean
    receiptPollAttempts?: number
    receiptValidationMode?: string | null
    receiptAccountId?: string | null
    receiptOpportunityId?: string | null
    receiptCreatedAt?: string | null
    errorMessage?: string | null
  } | null
  errorMessage?: string | null
}

export type AWSConfigMetaDataResponse = {
  prerequisites: {
    APNEnrolled: boolean
    solutionsConfigured: boolean
    ACEEligible: boolean
  }
  steps: {
    prerequisites: boolean
    linkAccount: boolean
    cloudDetails: boolean
    createIamRole: boolean
    solutionsSavedOnce: boolean
  }
  acknowledgedRequiredPersons: boolean
  acknowledgedCrmAdmin?: boolean
  stackType?: string | null
  aceEventReceiptValid?: AceEventReceiptValidField | null
}

export type G2ReviewResponseType = {
  id: string
  completed: boolean
  openedAt: string
  reviewType: string
  partnerId: string
}

export interface PartnerOwner {
  email?: string
  firstName?: string
  lastName?: string
  login?: string
  name?: string
}

export interface Users {
  email: string
  role: UserRoleForTable
}

export type SubscribeProducts = Record<
  string,
  {
    cloudProviders?: string[]
    plan?: string
    features?: string[]
    partnerIqEnabled?: boolean
    partnerIqOnboardingComplete?: boolean
  }
>

export interface AccountData {
  partnerId?: string
  id?: string
  crmId?: string
  iamArn?: string
  policyName?: string
  iamArnStaging?: string
  createdAt?: string
  updatedAt?: string
  contactEmail?: string
  name?: string
  companyName?: string
  syncPaused?: boolean
  partnerOwner?: PartnerOwner
  spmsId?: string
  aceS3BucketPath?: string
  awsRegion?: string
  firstSyncDate?: string
  activeProducts?: ActiveProducts
  activeProductsWithCloud?: string[]
  activeCloudProvider?: CloudType
  isInternal?: boolean
  awsSecurityPolicy?: string
  partnershipTier?: string | null
  partnershipType?: string | PartnershipTypeValue[]
  isIsv?: boolean
  isSrrp?: boolean
  accelerateProgram?: boolean
  industry?: string | null
  acceptedTermsAndConditions?: boolean
  prdAceS3BucketPath?: string
  stgAceS3BucketPath?: string
  websiteUrl?: string
  awsFieldsVersion?: string
  iamPolicyStaging?: string
  iamPolicyProduction?: string
  allowStoringPii?: boolean
  s3Status?: {
    production?: TestButtonStatus
    staging?: TestButtonStatus
  }
  hasAWSCustomCatalog?: boolean
  authProtocol?: AuthProtocol
  crmType?: CRMTypes
  subscribedProducts?: Partial<SubscribeProducts>
  quotationLink?: string
  internalNotes?: string
  numberOfSeats?: number
  includeLabraBot?: boolean
  users?: Users[]
  G2Review?: boolean
  G2ReviewList?: G2ReviewResponseType[]
  awsAccountId?: string
  msspProgram?: boolean
  securityServiceSoftwareOnly?: boolean
  securityServiceManagedServices?: boolean
  securityServiceProfessionalServices?: boolean
  awsConfigMetadata?: AWSConfigMetaDataResponse
  isSandbox?: boolean
  useAceApi?: boolean
  workatoCustomerId?: string
  plan?: string
}
